import { VendorHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/vendor-handler';
import { map } from 'lodash-es';
import {
  callbackDomain,
  VendorIdSource
} from '@portal/app/dashboard/integrations/shared/constants';
import {
  IOAuthDetails,
  IVendorConnectConfirmation,
  IVendorConnectInitRequest,
  IVendorConnectInitResponse
} from '@portal/app/dashboard/integrations/models/vendor/VendorIntegrationModels';
import { IVendorInitiateRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorInitiateRequest';
import { IVendorConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorConfigurationRequest';
import { IVendorOAuthConfirmationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorOAuthConfirmationRequest';
import { StorageService } from '@portal/app/shared/services/storage.service';
import { IVendorReConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorReConfigurationRequest';
import { WindowService } from '@portal/app/shared/services/window.service';

export class GAHandler implements VendorHandler {
  constructor(
    private storageService: StorageService,
    private windowService: WindowService
  ) {}

  prepareRequestObjectToInitiateVendor(
    vendorDetails: IVendorConnectInitRequest
  ): IVendorInitiateRequest {
    /* eslint-disable no-console */
    console.log(`Google Analytics initiation data: ${vendorDetails}`);
    return {
      req: {},
      queryParams: { callbackDomain: callbackDomain() },
      pathParams: { vendorId: VendorIdSource.ga }
    };
  }

  prepareRequestObjectToConfigureVendor(
    accounts: {
      accountName: string;
      accountId: string;
      clientAccountName?: string;
      managerId?: string;
      disabled: boolean;
    }[]
  ): IVendorConfigurationRequest {
    return {
      vendorId: VendorIdSource.ga,
      vendorData: map(accounts, (account) => ({
        profileId: account.accountId,
        clientAccountName: account.clientAccountName
      }))
    };
  }

  handleVendorInitiateResponse(data: IVendorConnectInitResponse): void {
    localStorage.setItem(
      'callBackParams',
      JSON.stringify(
        (data.vendorCredentialsDetails as IOAuthDetails).callbackParameters
      )
    );
    this.windowService.navigateToHref(
      (data.vendorCredentialsDetails as IOAuthDetails).redirectURL
    );
  }

  confirmVendor(data: IVendorConnectConfirmation): void {
    const jsonData = data.accountDetails
      ? JSON.stringify(data.accountDetails.vendorAccounts)
      : '';
    this.storageService.setIntegrationAccountDetails(
      VendorIdSource.ga,
      jsonData
    );
  }

  prepareRequestToConfirmVendor(): IVendorOAuthConfirmationRequest {
    return {
      code: `${localStorage.getItem('code')}`,
      state: `${localStorage.getItem('state')}`,
      callbackDomain: callbackDomain()
    };
  }

  prepareRequestObjectToReConfigureVendor(
    accounts: {
      accountName: string;
      accountId: string;
      managerId?: string | undefined;
      disabled: boolean;
    }[],
    dsInstanceIds: number[]
  ): IVendorReConfigurationRequest {
    return {
      vendorId: VendorIdSource.ga,
      vendorData: map(accounts, (account) => ({
        profileId: account.accountId
      })),
      dsInstanceIds
    };
  }
}
